import React, { useEffect, useState } from "react";
import { ProcessContext } from "../../../../../contexts/ProcessContext";
import Text from "../../../../shared/components/Text";
import { useActionCallback } from "../../../../../utils/hooks/useActionCallback";
import { FLOW_MESSAGES } from "../../../../shared/components/flowMessages/components";

export const useKycVideoVerification = ({ allowedLenders } = {}) => {
  const {
    state: { loan, participant },
    dispatch,
  } = React.useContext(ProcessContext);

  const [electronicIdSubmitted, setElectronicIdSubmitted] = useState(false);
  const kycId = participant?.onboardingDetails?.kyc_id;

  useEffect(() => {
    const lenderName = loan?.loan_application_selected?.lender_name;
    if (
      (allowedLenders && lenderName && !allowedLenders.includes(lenderName)) ||
      kycId
    ) {
      dispatch({ type: "SET_MODULE_SKIPPED" });
    }
  }, [kycId]);

  useEffect(() => {
    if (
      participant &&
      participant.onboardingDetails?.user_details?.document_id
        ?.document_type === "nie_eu"
    ) {
      dispatch({
        type: "REQUEST_GET_BORROWER_DOCUMENTATION_FILE_BY_LOAN_ID_BORROWER_ID_AND_FILE_TYPE",
        payload: {
          loanId: loan.id,
          borrowerId: participant.participantId,
          fileType: "passport",
        },
      });
    }
  }, [participant]);

  const dispatchModuleOkRequests = () => {
    dispatch({
      type: "UPDATE_PROCESS_CONTEXT",
      payload: { videoIdProcessPassed: true },
    });
    dispatch({ type: "SET_FLOW_ITEM_OK" });
    dispatch({ type: "SET_FLOW_LOADING", payload: { show: false } });
    dispatch({
      type: "SET_FLOW_MESSAGE",
      payload: { id: FLOW_MESSAGES.SEND_OK.id, fadeIn: false },
    });
  };

  const onSubmitKycElectronicId = (electronicIdValues) => {
    setElectronicIdSubmitted(true);
    dispatch({
      type: "SET_FLOW_LOADING",
      payload: {
        show: true,
        loadingMessage: <Text tId="PLEASE_WAIT" />,
      },
    });
    dispatch({
      type: "REQUEST_PATCH_SUBMIT_KYC_VERIFICATION",
      payload: {
        op: "processPatchSubmitKycVerification",
        id: participant.participantId,
        loan_id: loan.id,
        images_request_id: electronicIdValues.requestId,
      },
    });
  };

  useActionCallback("REQUEST_PATCH_SUBMIT_KYC_VERIFICATION_FULFILLED", () => {
    dispatchModuleOkRequests();
  });

  useActionCallback(
    "REQUEST_PATCH_SUBMIT_KYC_VERIFICATION_REJECTED",
    (action) => {
      if (action.payload?.data?.exception?.includes("KycDuplicateException")) {
        dispatchModuleOkRequests();
        return;
      }
      setElectronicIdSubmitted(false);
      dispatch({ type: "SET_FLOW_LOADING", payload: { show: false } });
    }
  );

  return {
    electronicIdSubmitted,
    setElectronicIdSubmitted,
    onSubmitKycElectronicId,
  };
};
